import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";

const words = ["Hair", "Skin", "Makeup", "Nails", "Grooming", "Bridal", "Spa", "Threading"];

export default function EditorialMarquee() {
  return (
    <div
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="bg-deep text-cream py-6 overflow-hidden select-none"
    >
      <Marquee speed={35} gradient={false} pauseOnHover={false}>
        {words.map((w) => (
          <span key={w} className="flex items-center gap-8 mx-8">
            <span className="font-display italic text-2xl md:text-3xl text-cream/90">{w}</span>
            <Diamond size={12} className="text-accent fill-accent" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
